import { render, staticRenderFns } from "./POIStep.vue?vue&type=template&id=24e54209"
import script from "./POIStep.js?vue&type=script&lang=js&external"
export * from "./POIStep.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports